/**
 * The one place a tag value turns into text a human reads (issue #1410).
 *
 * Everything upstream keeps the raw value: it is the grouping key, the colour
 * key, the filter-match key and the `data-*` identity in the DOM. Only the
 * displayed string changes — exactly the contract `criteriaLabels` already
 * proves for criteria ids.
 */

/** Empty-string tag values are real, distinct groups — label them visibly. */
export const EMPTY_TAG_VALUE_LABEL = "(empty)";

/**
 * A tag value as it should be read: its workspace display name if it has one,
 * otherwise the value itself.
 */
export function formatTagValue(
  value: string,
  aliases: Record<string, string> = {},
): string {
  const alias = aliases[value];
  if (alias) return alias;
  return value === "" ? EMPTY_TAG_VALUE_LABEL : value;
}
